import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button, TextField } from "@mui/material";
// import { icons, months, appConstants } from "../../helpers/constants";
import "./TransactionDialog.css";
import { Slide } from "@mui/material";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../interceptor/interceptor";
import CircularProgress from "@mui/material/CircularProgress";
// radio button
// import Radio from '@mui/material/Radio';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

// Package for datepicker
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { changeDateFormat, escapeHtml } from '../../helpers/common';
import { useSelector, useDispatch } from "react-redux";
import { tagActions } from "../../actions/tag.action";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function TransactionDialog(props) {
  const {
    open,
    closeHandler,
    budgetId,
    budgetName,
    refreshData,
    budgetAmount,
    transactionDate,
    transactionId,
    tagId,
    accountId,
    note,
    transactionType,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const minDate = dayjs().startOf('month').add(1, 'day').set('year', 2000).format('YYYY-MM-DD HH:mm:ss');
  const maxDate = dayjs().startOf('month').add(1, 'day').set('year', 2100).format('YYYY-MM-DD HH:mm:ss');
  const dispatch = useDispatch();

  const [inputField, setInputField] = React.useState({
    budget_id: "",
    user_id: localStorage.getItem("user_text_obj_data1"),
    name: budgetName ? budgetName : "",
    amount: "",
    transaction_date: dayjs(),
    transaction_id:"",
    tag_id:"",
    account_id:"",
    note: "",
  });
  const startDate = useSelector((state) => state.varsReducer.startDate);
  const endDate = useSelector((state) => state.varsReducer.endDate);
  const tags = useSelector((state) => state.tagReducer.tags);
  const activeTags = tags.filter(item=> item.is_archived == 0);
  const accounts = useSelector((state) => state.accountReducer.accounts);
  const activeAccount = accounts.filter(item=> item.is_archived==0);
  
  const inputsHandler = (e) => {
    if(e.target.name === "note" && e.target.value.length > 85){
      setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,85) });
    }
    else if(e.target.name === "amount"){
      if(isNaN(e.target.value)){
        setInputField({ ...inputField, [e.target.name]:  e.target.value.substring(0,e.target.value.length-1) }); //
      }
      else if(e.target.value.length>8){
        setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,8) });
      }
      else {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
      }
    }
    else {
      setInputField({ ...inputField, [e.target.name]: e.target.value });
    }
  };

  const inputsHandler2 = (newVal) => {
    setInputField({ ...inputField, transaction_date: newVal });
  };

  const handleClose = () => {
    closeHandler();
  };
  // Component Did Mount
  useEffect(() => {
    fetchTags();
    setInputField({
      ...inputField,
      budget_id: "",
      name: "",
      amount: "",
      transaction_date: "",
      transaction_id: "",
      tag_id: "",
      account_id: "",
      note: ""
    });
  }, []);

  // Fetch tags
  function fetchTags() {
    try {
      const user_id = localStorage.getItem("user_text_obj_data1");
      dispatch(tagActions.fetchTags({ user_id: user_id }));
    } catch (e) {
      alert(e);
    }
  }

  // Should Component Update
  useEffect(() => {
    setInputField({
      ...inputField,
      budget_id: budgetId,
      name: budgetName,
      amount: budgetAmount,
      transaction_date: transactionDate ?  dayjs(transactionDate) : dayjs(),
      transaction_id: transactionId,
      tag_id: tagId,
      account_id: accountId,
      note: note
    });
  }, [props]);

  const handleSubmit = async () => {
    try {
      // Form validation
      if (inputField.amount==="" || isNaN(inputField.amount) || parseInt(inputField.amount) < 1) {
        toast.info("Enter correct value in Amount field", { type: "error" });
        return false;
      }
  
      let obj = {};
      obj = { ...inputField };
      obj.user_id = localStorage.getItem("user_text_obj_data1");
      obj.transaction_date = changeDateFormat(inputField.transaction_date);
      if(new Date(obj.transaction_date).setHours(0,0,0,0) >= new Date(startDate).setHours(0,0,0,0)  && new Date(obj.transaction_date).setHours(0,0,0,0) <= new Date(endDate).setHours(0,0,0,0)){
        setIsLoading(true);
        const res = await axiosInstance.post(
          `api?method=manage_transaction`,
          obj
        );
        setInputField({
          ...inputField,
          amount: "",
          note: "",
        });

        setIsLoading(false);
        toast(res.data.message);
        closeHandler();
        refreshData();

      }
      else {
        toast.info(`Transaction Date is out of selected month range!`, { type: "error" });
      }
    } catch (error) {
      setIsLoading(false);
      if(error.code !== 'ERR_NETWORK'){
        toast.info(`Error: ${error}`, { type: "error" });
      }
      // console.error("Please check your internet connection.");
    }
  };

  const conditionalRender = (index, tag_id) => {
    if(inputField.tag_id == tag_id) {
       return <input type="radio" id={"tag"+index} name="tag_id" value={tag_id == undefined ? null: tag_id} checked={true} onChange={inputsHandler} />;
    }
    else{
       return <input type="radio" id={"tag"+index} name="tag_id" value={tag_id == undefined ? null: tag_id} checked={false} onChange={inputsHandler} />;
    }
 }

 const conditionalRender2 = (index, account_id) => {
  if(inputField.account_id == account_id) {
    return <input type="radio" id={'account'+index} name="account_id" value={account_id == undefined ? null: account_id} checked={true} onChange={inputsHandler} />
  }
  else{
     return <input type="radio" id={'account'+index} name="account_id" value={account_id == undefined ? null: account_id} checked={false} onChange={inputsHandler} />
  }
}

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="modalBudgetForm"
      >
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            cursor: "pointer",
            right: 10,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        />
        <DialogTitle>
          {inputField.budget_id !== "0" ? (
            <>{escapeHtml(inputField.name)}</>
          ) : (
            <>Save Payment</>
          )}
        </DialogTitle>

        <form className="transaction-dialog-form">
          <DialogContent>
            {/* <Typography>{inputField.name}</Typography> */}
            {/* <TextField
              value={inputField.name}
              onChange={inputsHandler}
              style={{ marginBottom: "10px", width: "100%", color: "#fff" }}
              type="text"
              label="Name"
              variant="outlined"
              name="name"
              disabled={true}
            /> */}
            <br />
            <TextField
              style={{ marginBottom: "20px", width: "100%" }}
              name="amount"
              type="number"
              label="Amount"
              variant="outlined"
              value={inputField.amount}
              onChange={inputsHandler}
            />
            <br />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDatePicker
                label="Transaction Date"
                value={inputField.transaction_date}
                minDate ={minDate}
                maxDate = {maxDate}
                onChange={(newValue) => {
                  inputsHandler2(newValue);
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <br />
            <br />

            <TextField
              name="note"
              type="text"
              label="Note"
              variant="outlined"
              value={inputField.note}
              onChange={inputsHandler}
            />
            {/* { activeTags.length > 0 &&  
            <> <br/><br/>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Tag</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="tag_id"
                value={inputField.tag_id}
                style={{display:"block"}}
              >
                {activeTags.map((tag,index) => (
                  <FormControlLabel key={index} onChange={inputsHandler} value={tag.tag_id} control={<Radio />} label={tag.name} />
                ))}
              </RadioGroup>
          </FormControl></> } */}
          {activeTags.length > 0 &&
            <> <br/><br/>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label" style={{marginBottom: '5px'}}>Tag</FormLabel>
              <div>
                {activeTags.map((tag,index) => (
                  <span  key={index} className="radio-span">
                    { conditionalRender(index, tag.tag_id) }
                    {/* <input type="radio" id={'tag'+index} name="tag_id" value={tag.tag_id} onChange={inputsHandler} /> */}
                    <label className="radio-label" htmlFor={'tag'+index}>{tag.name}</label>
                    </span>
                  ))}
                </div>
          </FormControl></> }
          {/*  */}
          {/* {(activeAccount.length && transactionType === "Expense") > 0 &&   checked={tag.tag_id ==inputField.tag_id}
            <> <br/><br/>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Account</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="account_id"
                value={inputField.account_id}
                style={{display:"block"}}
              >
                {activeAccount.map((account,index) => (
                  <FormControlLabel key={index} onChange={inputsHandler} value={account.account_id} control={<Radio />} label={account.name} />
                ))}
              </RadioGroup>
          </FormControl></> } */}

          {(activeAccount.length && transactionType === "Expense") > 0 &&  
            <> <br/>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label" style={{marginBottom: '5px'}}>Account</FormLabel>
              <div>
                {activeAccount.map((account,index) => (
                  <span  key={index} className="radio-span">
                    { conditionalRender2(index, account.account_id) }
                    {/* <input type="radio" id={'account'+index} name="account_id" checked={account.account_id ===inputField.account_id} value={account.account_id} onChange={inputsHandler} /> */}
                    <label className="radio-label" htmlFor={'account'+index}>{account.name}</label>
                    </span>
                  ))}
                </div>
          </FormControl></> }


          </DialogContent>

          <DialogActions>
            {transactionId ? (
              <Button onClick={handleSubmit} variant="outlined">Update</Button>
            ):(
              <Button onClick={handleSubmit} variant="outlined">Add</Button>
            )}
            
          </DialogActions>
        </form>
      </Dialog>
      {isLoading === false ? (
        <></>
      ) : (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      )}
    </div>
  );
}
